import axios from 'axios';
import queryString from 'query-string';

import { env } from 'env';
import { SELECTED_ENTITY, USER_ID } from 'types';

// Please have a look at here `https://github.com/axios/axios#request-config` for the full list of configs
const { CancelToken } = axios;
export const sourceCancel = CancelToken.source();

const baseURLEntity = `${env.service.entityService}/api/v1`;

// entity service
const entityService = axios.create({
  baseURL: baseURLEntity,
  cancelToken: sourceCancel.token,
  headers: {
    accept: 'application/json',
    'Content-Type': 'application/json',
  },
  paramsSerializer: params => queryString.stringify(params),
});

entityService.interceptors.response.use(
  response => {
    if (response && response.data) {
      return response.data;
    }
    return response;
  },
  error => {
    if (
      error.response.data?.message === 'Invalid access domain' &&
      error.response.status === 403
    ) {
      localStorage.removeItem(USER_ID);
      localStorage.removeItem(SELECTED_ENTITY);
      updateTokenBearer('');
      window.location.replace('/admin');
    }
    throw error;
  }
);

export const getTokenBearer = () =>
  entityService.defaults.headers.common.Authorization;

export const updateTokenBearer = token => {
  entityService.defaults.headers.common.Authorization = token;
};

export const updateTokenID = token => {
  entityService.defaults.headers.common['token-id'] = token;
};

export const updateCurrentEntity = (entityID, type) => {
  entityService.defaults.headers.common['entity-id'] = entityID;
  entityService.defaults.headers.common.type = type;
};

export const removeCurrentEntity = () => {
  delete entityService.defaults.headers.common['entity-id'];
  delete entityService.defaults.headers.common.type;
};

export const updateUserAgent = (content: string): void => {
  entityService.defaults.headers.common['user-agent-hub'] = content;
};

export const removeUserAgent = (): void => {
  const value = entityService.defaults.headers.common['user-agent-hub'];
  delete entityService.defaults.headers.common['user-agent-hub'];
  return value;
};

export const updateBaseURL = (url: string): void => {
  entityService.defaults.baseURL = url;
};

export default entityService;
